import select from 'dom-select'
import on from 'dom-event'
import inViewport from 'in-viewport'
import { set, unset, toggle, isOver } from 'utils/general'

const getRatio = (el) => {
  return el.offsetHeight / el.offsetWidth
}

const updateVideo = (video, container) => {
  if (getRatio(video) > getRatio(container)) {
    video.style.height = 'auto'
    video.style.width = '100%'
  } else {
    video.style.height = '100%'
    video.style.width = 'auto'
  }
}

const onTooglePlay = (btn, video) => {
  toggle(btn, 'active')
  if (video.paused) {
    video.play()
  } else {
    video.pause()
    video.setAttribute('block-scroll-listener', true)
  }
}

const onToogleMute = (btn, video) => {
  toggle(btn, 'active')
  video.muted = !video.muted
}

const onResize = (video, el) => {
  updateVideo(video, el)
}

const onShowControls = (controls, timerControls) => {
  controls.setAttribute('data-showing-controls', 'true')
  set(controls, 'active')
  window.clearTimeout(timerControls)
}

const onHideControls = (controls, timerControls) => {
  controls.setAttribute('data-showing-controls', 'false')
  timerControls = window.setTimeout(() => {
    if (controls.getAttribute('data-showing-controls') === 'true') {
      onShowControls(controls, timerControls)
    } else {
      unset(controls, 'active')
    }
  }, 5000)
}

function checkScroll (video, tooglePlay) {
  if (!video.hasAttribute('block-scroll-listener')) { // Stop autoplay on scroll ones user clicked on pause
    const docViewTop = window.scrollY
    const elemTop = video.getBoundingClientRect().top
    if ((docViewTop <= ((elemTop - window.innerHeight) + (window.innerHeight / 2))) || (docViewTop >= ((elemTop + docViewTop) + (window.innerHeight / 2)))) {
      video.pause()
      set(tooglePlay, 'active')
    } else {
      video.play()
      unset(tooglePlay, 'active')
    }
  }
}

export default el => {
  const video = select('video', el) || false
  const videoControls = select('.video-container__controls', el) || false
  const tooglePlay = select('.video__toogle_play', el) || false
  const toogleMute = select('.video__toogle_mute', el) || false
  let timerControls

  /**
   * '786' is a rudimentary number that
   * should be changed as need be within the
   * development phase of the project.
   */
  if (video && isOver('768')) {
    video.onloadedmetadata = () => {
      updateVideo(video, el)
      video.play()
      /**
      * Show controls at the beginning for 5s
      */
      onShowControls(videoControls, timerControls)
      onHideControls(videoControls, timerControls)
    }

    on(window, 'resize', () => onResize(video, el))
    on(el, 'mouseenter', () => { onShowControls(videoControls, timerControls) })
    on(el, 'mouseleave', () => { onHideControls(videoControls, timerControls) })
    on(tooglePlay, 'click', () => { onTooglePlay(tooglePlay, video) })
    on(toogleMute, 'click', () => { onToogleMute(toogleMute, video) })

    inViewport(el, {
      offset: 0,
      failsafe: false
    }, () => {
      const src = video.getAttribute('data-src')
      // Can't use truthy as src could be 'false' as string
      const hasSrc = typeof src !== 'undefined' && ![false, 'false', ''].includes(src)

      if (hasSrc) {
        video.setAttribute('src', video.getAttribute('data-src'))
        set(el, 'is-loaded')
        /**
        * Pause video once it's out of viewport
        */
        on(window, 'scroll', () => { checkScroll(video, tooglePlay) })
        on(window, 'resize', () => { checkScroll(video, tooglePlay) })
      }
    })
  }
}
